import React, { useEffect, useState } from "react";
import SmallLogo from "../assets/logo/small-logo.svg";
import GameCategoryCard from "../components/GameCategoryCard";
import { gameCategoryCards } from "../constants/const";
import { useNavigate } from "react-router";
import { getLevelPricesNano, getMegaJackpotInfo } from "../blockchain/lotteryClient";
import ProgressChartMini from "../components/ProgressChartMini";
import { Spin } from "antd";

type MegaInfo = {
    balance: bigint;
    threshold: bigint;
    isActive: boolean;
};

function AuthLayout() {
    const navigate = useNavigate();
    const [isLoadingMega, setIsLoadingMega] = useState(true);
    const [isLoadingPrices, setIsLoadingPrices] = useState(true);

    const isLoading = isLoadingMega || isLoadingPrices;
    const [priceArray, setPriceArray] = useState<Array<number | null>>([]);
    const [megaProgressPercent, setMegaProgressPercent] = useState<number>(0);
    const [isMegaActive, setIsMegaActive] = useState(false);
    const cards = gameCategoryCards.map((card, index) => ({
        ...card,
        ticketPrice: priceArray[index] ?? null,
    }));


    useEffect(() => {
        let cancelled = false;

        async function loadMega() {
            try {
                setIsLoadingMega(true);

                const info = await getMegaJackpotInfo() as MegaInfo | null;
                if (!info || cancelled) return;

                const balance = BigInt(info.balance ?? 0n);
                const threshold = BigInt(info.threshold ?? 0n);

                const rawPercent = threshold > 0n
                    ? Number((balance * 10000n) / threshold) / 100
                    : 0;
                const clampedPercent = Math.max(0, Math.min(100, rawPercent));

                setMegaProgressPercent(clampedPercent);
                setIsMegaActive(info.isActive === true);

            } catch (e) {
                console.error("Failed to load mega jackpot", e);
            } finally {
                if (!cancelled) setIsLoadingMega(false);
            }
        }

        loadMega();

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        let cancelled = false;

        async function loadPrices() {
            try {
                setIsLoadingPrices(true);

                const levels = [0, 1, 2];

                const pricesNano = await getLevelPricesNano(levels);

                if (cancelled) return;

                const pricesTon = pricesNano.map((value) => Number(value) / 1e9);

                setPriceArray(pricesTon);
            } catch (e) {
                if (!cancelled) {
                    setPriceArray([null, null, null]);
                }
            } finally {
                if (!cancelled) setIsLoadingPrices(false);
            }
        }

        loadPrices();

        return () => {
            cancelled = true;
        };
    }, []);

    const handleOpenGame = (index: number) => {
        switch (index) {
            case 0:
                localStorage.setItem("gameName", "regular-game");
                navigate("/jackpot");
                break;
            case 1:
                localStorage.setItem("gameName", "standard-game");
                navigate("/jackpot");
                break;
            case 2:
                localStorage.setItem("gameName", "premium-game");
                navigate("/jackpot");
                break;
            default:
                navigate("*");
        }
    };

    // Mega tickets are on sale only while the contract has the Mega Jackpot active.
    const isMegaUnlocked = isMegaActive;
    const handleMegaJackpotPage = () => navigate("/mega-jackpot");

    return (
        <div className="auth-layout">
            {isLoading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(0, 0, 0, 0.65)",
                        zIndex: 9999
                    }}
                >
                    <Spin size="large" />
                </div>
            )}
            <img src={SmallLogo} alt="logo" width="129" height="73" />

            <div className="games-category">
                <div className="games-category_header">
                    <div className="games-category_header__title">
                        Игры
                    </div>
                </div>

                {cards.map((cardItem, index) => (
                    <GameCategoryCard
                        key={cardItem.name}
                        gameIcon={cardItem.icon}
                        name={cardItem.name}
                        subTitle={cardItem.subTitle}
                        ticketPrice={cardItem.ticketPrice}
                        func={() => handleOpenGame(index)}
                    />
                ))}

                <div className="mega-jackpot-game-card-process">
                        <div className="mega-jackpot-game-card-process_left">
                            <div className="mega-jackpot-game-card-process_left__title">
                                Мега Джекпот
                            </div>
                            <div className="mega-jackpot-game-card-process_left__content">
                                СТАРТ когда Призовой фонд сформирован на 100%
                            </div>
                        </div>
                        <div>
                            {isMegaUnlocked ?
                                <div className="mega-jackpot-cta" onClick={handleMegaJackpotPage}>
                                    <span>Купить билет</span>
                                </div>
                                :
                                <ProgressChartMini
                                    percent={megaProgressPercent}
                                />
                            }
                        </div>
                    </div>

            </div>
        </div>
    );
}

export default AuthLayout;
